import React, {
  FunctionComponent, useCallback, useEffect, useRef, useState,
} from 'react';
import { Box, Text } from 'rebass/styled-components';
import api from '../../api';
import { useAppState } from '../../hooks';
import { CopyableText } from '..';
import { ReactComponent as IconInfo } from '../../assets/icon-info.svg';

const copyText = require('./copy-text.json');

const { OAUTH_V2_TITLE, OAUTH_V2_DETAIL } = copyText;

const MasterToken: FunctionComponent<{}> = () => {
  const [token, setToken] = useState<string>('');
  const { accountId } = useAppState();
  const isMounted = useRef<boolean>(false);

  const fetchToken = useCallback(
    async () => {
      const res = await api.ccsV2.getMasterUserToken(accountId);
      if (isMounted.current) {
        setToken(res);
      }
    }, [accountId],
  );

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (accountId) {
      fetchToken();
    }
  }, [accountId, fetchToken]);

  return (
    <Box>
      <Text variant="h2">
        {OAUTH_V2_TITLE}
      </Text>
      <Box>
        <Text variant="p1" mb={3} mt={2}>
          {OAUTH_V2_DETAIL}
        </Text>
        {token && (
        <>
          <Box flex={1} height="42px" pr={3} mt={5} mb={5} maxWidth="960px">
            <CopyableText text={token} copyEnabled={!!token} testId="master-token-content" />
          </Box>
          {/* <Flex mb={2}>
            <Text variant="h3" mr={2}>
              <IconInfo />
            </Text>
            <Text variant="h3" mr={2}>
              Need a new token?
            </Text>
          </Flex>

          <Text variant="p1">
            If you got an invalid error while testing APIs on Postman or other testing
            tools, just refresh this page and a new secure token will be generated for you.
          </Text> */}
        </>
        )}
        {/* Leaving this in because I think it makes more sense to have a regenerate
        token button than to ask user to refresh the page */}
        {/* <Flex mt={4}>
            <Button
              variant="secondary"
              onClick={fetchToken}
              data-testid="reload-button"
            >
              {token ? 'Regenerate token' : 'Generate token'}
            </Button>
          </Flex> */}
      </Box>
    </Box>
  );
};

export default MasterToken;
